import { FieldError } from "react-hook-form";
import { FormGroupContext } from "./formGroupContext";
import { Box } from "../box";
import { CSS } from "utils";

type Props = React.HTMLAttributes<HTMLDivElement> & {
  error?: FieldError;
  css?: CSS;
};

const FormGroup: React.FC<Props> = ({ error, ...props }) => {
  return (
    <FormGroupContext.Provider value={{ error }}>
      <Box {...props} />
    </FormGroupContext.Provider>
  );
};

export { FormGroup };
